import { render, staticRenderFns } from "./Cardiology.vue?vue&type=template&id=272b5a56&scoped=true"
import script from "./Cardiology.vue?vue&type=script&lang=js"
export * from "./Cardiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b5a56",
  null
  
)

export default component.exports